import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionButton from "../general/NtSectionButton";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";

function NtHomeBYODSection(props) {
  const nav = useNavigation();
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/fab03ee8cf29566f0aebc1eae75a5cae357c4a08.png")}
    >
      <NtSectionDescription style={{ fontSize: 12, fontWeight: "300" }}>
        BRING YOUR OWN DEVICE!
      </NtSectionDescription>
      <NtSectionTitle style={{ fontWeight: "300", marginTop: 8 }}>
        USE OUR EXCLUSIVE{" "}
        <NtSectionTitle style={{ fontWeight: "599" }}>TALK APP</NtSectionTitle>
      </NtSectionTitle>
      <NtSectionDescription
        style={{
          textAlign: "center",
          marginTop: 8,
        }}
      >
        Our most powerful solution yet.
      </NtSectionDescription>

      <NtSectionButton
        containerStyle={{ marginTop: 10 }}
        title="LEARN MORE"
        color="white"
        onPress={() => {
          nav.navigate(routes.mobile);
        }}
      />

      <Image
        style={[
          {
            marginTop: 30,
            width: 150,
            height: 300,
            resizeMode: "contain",
          },
        ]}
        source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
      />
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    height: 600,
  },
});

export default NtHomeBYODSection;
